// ----------------------------------------------------------------------------
// Snippet: Breadcrumbs
// ----------------------------------------------------------------------------
//
// ----------------------------------------------------------------------------


// -------------------------------------
// Dependencies
// -------------------------------------

// Styles
import './_breadcrumbs.scss';

const BACK_HISTORY_BUTTON = '#js--back-history';

// Function to go back in history
function goBack() {
    history.back();
}

// Attach event listener to button
document.addEventListener('DOMContentLoaded', function() {
    const backHistoryButton = document.querySelector(BACK_HISTORY_BUTTON);
    if (backHistoryButton) {
        backHistoryButton.addEventListener('click', goBack);
    }
});